export default function Features() {
  const features = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Smart Estimates',
      description: 'AI suggests pricing based on trade standards',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Invoice Automation',
      description: 'Send, track, and get paid faster',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Job Scheduling',
      description: 'Visual calendar synced across your team',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Client CRM',
      description: 'Track conversations, preferences, and history',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Info Center for Trades',
      description: 'Startup guidance, pricing tips, and workflow advice tailored to your trade and experience',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile-First',
      description: 'Manage everything from the job site',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-team-line',
      title: 'Team Collaboration',
      description: 'Assign tasks and share updates instantly',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Business Insights',
      description: 'Understand your numbers without an accountant',
      gradient: 'from-[#1a2332] to-[#2563eb]'
    }
  ];

  return (
    <section className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Everything you need. Nothing you don't.
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Purpose-built tools for contractors, not adapted from generic business software
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all group cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {feature.description}
              </p>
              <a href="#" className="text-[#ff6b35] text-sm font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Learn more
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
